export default __webpack_public_path__ + "static/media/Mark-3-HUD-Artificial Horizon.02417dd5.jpg";